import axios from "axios";
import { getAccessToken } from "./jwt.js";
import { API_BASE_URL } from "../utils/config";
import { forceLogout } from "./session";

const SUSPENDED_MESSAGE =
  "Akun Anda ditangguhkan oleh admin. Hubungi admin untuk informasi lebih lanjut.";

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 15000,
});

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (error.response?.data?.code === "account_suspended") {
        forceLogout({ message: SUSPENDED_MESSAGE });
      } else {
        console.warn("Unauthorized – token expired or invalid");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
